<div class="shop-addresses">
  <h2>My Delivery Addresses</h2>

  <!-- Form to add or update an address -->
  <form (ngSubmit)="isUpdating ? updateShopAddress() : createShopAddress()">

    <div class="input-container">
      <label for="address">Address</label>
      <input type="text" id="address" [(ngModel)]="currentAddress.address" name="address" placeholder="Address" required>
    </div>

    <div class="input-container">
      <label for="email">Email</label>
      <input type="email" id="email" [(ngModel)]="currentAddress.email" name="email" placeholder="Email" required>
    </div>

    <div class="input-container">
      <label for="city">City</label>
      <input type="text" id="city" [(ngModel)]="currentAddress.city" name="city" placeholder="City" required>
    </div>

    <div class="input-container">
      <label for="state">State</label>
      <input type="text" id="state" [(ngModel)]="currentAddress.state" name="state" placeholder="State" required>
    </div>

    <div class="input-container">
      <label for="country">Country</label>
      <input type="text" id="country" [(ngModel)]="currentAddress.country" name="country" placeholder="Country" required>
    </div>

    <div class="input-container">
      <label for="zipcode">Zip Code</label>
      <input type="text" id="zipcode" [(ngModel)]="currentAddress.zipcode" name="zipcode" placeholder="Zip Code" required>
    </div>

    <div class="input-container">
      <label for="phone">Phone</label>
      <input type="number" id="phone" [(ngModel)]="currentAddress.phone" name="phone" placeholder="Phone" required>
    </div>

    <div class="input-container">
      <label for="cardname">Card Name</label>
      <input type="text" id="cardname" [(ngModel)]="currentAddress.cardname" name="cardname" placeholder="Card Name" required>
    </div>

    <div class="input-container">
      <label for="cardnum">Card number</label>
      <input type="number" id="cardnum" [(ngModel)]="currentAddress.cardnum" name="cardnum" placeholder="Card Number" required>
    </div>

    <div class="input-container">
      <label for="cardexp">Card Expiry</label>
      <input type="month" id="cardexp" [(ngModel)]="currentAddress.cardexp" name="cardexp" required>
    </div>

    <div class="input-container">
      <label for="cvv">CVV</label>
      <input type="number" id="cvv" [(ngModel)]="currentAddress.cvv" name="cvv" placeholder="CVV" required>
    </div>

    <div class="input-container">
      <label for="status">Statut</label>
      <input type="checkbox" id="status" [(ngModel)]="currentAddress.status" name="status">
      <label for="status">Activer</label> <!-- Label for checkbox -->
    </div>

    <!-- Buttons to submit the form or cancel -->
    <button type="submit">{{ isUpdating ? 'Update' : 'Create' }}</button>
    <button type="button" (click)="resetForm()">Annuler</button>
  </form>

  <!-- Affichage d'un message d'erreur si nécessaire -->
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <!-- Liste des adresses existantes -->
  <ul>
    <li *ngFor="let address of addresses">
      <span>{{ address.address }} - {{ address.city }}</span>
      <button (click)="editShopAddress(address)">Edit</button>
      <button (click)="deleteShopAddress(address.id!)">Delete</button>
    </li>
  </ul>
</div>
